export const common: object = {
  common: {
    cancel: 'Cancel',
    delete: 'Delete',
    remove: 'Remove',
    edit: 'Edit',
    here: 'here',
    back: 'Back',
    submit: 'Submit',
    continue: 'Continue',
    save: 'Save',
    done: 'Done',
    home: 'Home',
    dot: '.',
    colon: ':',
    braces: '({{parameter}})',
    braceOpen: '(',
    braceClose: ')',
    more: 'More',
    less: 'Less',
    optional: '(Optional)',
    sapAppCenter: 'SAP App Center',
    parameter: '{{parameter}}',
    errors: {
      somethingWrong: 'Something went wrong'
    },
  },

  pageMetaResolver: {
    noProductsFound: 'No solutions found for',
    resultsFor: '{{count}} Results for',
    facetResult: '{{count}} Results',
    productUnavailable: 'The selected solution is not available',
  },
};
